export const views = {
  month: 'month',
  week: 'week',
  day: 'day',
};
